import { CaretLeft, CaretRight } from '@phosphor-icons/react';
import { DAY_NAMES_ES_SHORT, MONTH_NAMES_ES, sameDate } from '../utils/weeklyCalendar';

export default function WeeklyCalendarShell({
  month,
  year,
  weeks,
  onChangeMonth,
  activeWeekIdx,
  leftHeaderLabel = 'Semana',
  legendItems = [],
  dayNames = DAY_NAMES_ES_SHORT,
  monthNames = MONTH_NAMES_ES,
  getWeekRowClassName,
  renderWeekLeft,
  getDayCell,
  renderWeekOverlay,
}) {
  return (
    <>
      <div className="flex items-center justify-between">
        <div className="grid w-full grid-cols-[44px_minmax(0,1fr)_44px] items-center gap-3 lg:flex lg:w-auto lg:gap-3">
          <button
            type="button"
            onClick={() => onChangeMonth(-1)}
            className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-surface-2 text-content hover:text-content lg:h-8 lg:w-8"
            aria-label="Mes anterior"
          >
            <CaretLeft size={18} className="lg:h-3.5 lg:w-3.5" />
          </button>
          <h2 className="min-w-0 truncate text-center text-lg font-bold text-content sm:text-xl lg:text-left">{monthNames[month]} {year}</h2>
          <button
            type="button"
            onClick={() => onChangeMonth(1)}
            className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-surface-2 text-content hover:text-content lg:h-8 lg:w-8"
            aria-label="Mes siguiente"
          >
            <CaretRight size={18} className="lg:h-3.5 lg:w-3.5" />
          </button>
        </div>

        {legendItems.length > 0 && (
          <div className="hidden lg:flex items-center gap-6 text-content">
            {legendItems.map((item) => (
              <span key={item.label} className="inline-flex items-center gap-2">
                <span className="w-3 h-3 rounded-full" style={{ backgroundColor: item.color }} />
                {item.label}
              </span>
            ))}
          </div>
        )}
      </div>

      <div className="rounded-2xl border border-line overflow-hidden bg-surface">
        <div className="grid grid-cols-[64px_repeat(7,minmax(0,1fr))] md:grid-cols-[180px_repeat(7,minmax(0,1fr))] bg-table-head border-b border-line">
          <div className="px-3 md:px-4 py-4 text-content font-semibold"><span className="sr-only md:not-sr-only">{leftHeaderLabel}</span></div>
          {dayNames.map((name) => (
            <div key={name} className="px-2 md:px-4 py-4 text-center font-semibold">{name}</div>
          ))}
        </div>

        {weeks.map((week, weekIndex) => (
          <div
            key={week.weekNumber}
            className={`grid grid-cols-[64px_repeat(7,minmax(0,1fr))] md:grid-cols-[180px_repeat(7,minmax(0,1fr))] border-b border-line last:border-b-0 ${getWeekRowClassName ? getWeekRowClassName({ week, weekIndex, activeWeekIdx }) : 'bg-surface'}`}
          >
            {renderWeekLeft({ week, weekIndex })}

            <div className="col-span-7 relative">
              <div className="grid grid-cols-7 h-full">
                {week.days.map((day, dayIndex) => {
                  const cell = getDayCell({
                    day,
                    dayIndex,
                    week,
                    weekIndex,
                    isCurrentMonth: day.getMonth() === month,
                    isToday: sameDate(day, new Date()),
                  });

                  return (
                    <div
                      key={`${week.weekNumber}-${dayIndex}`}
                      className={cell.className}
                      style={cell.style}
                    >
                      {cell.content}
                    </div>
                  );
                })}
              </div>

              {renderWeekOverlay ? renderWeekOverlay({ week, weekIndex }) : null}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
